import React from 'react';
import PropTypes from 'prop-types';

import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

import Modal from 'shared/dialog';

const WarningModal = ({
  onConfirm,
  onHide,
  show,
  voucherCount,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  const plural = voucherCount > 1;

  return (
    <Modal
      className="voucher-approval-warning-modal"
      confirmLabel="Yes, Reset Workflow"
      headerText="Reset Approval Workflow"
      icon={faCircleExclamation}
      iconClassName="text-warning"
      show={show}
      onConfirm={handleConfirm}
      onHide={onHide}
    >
      <div className="voucher-approval-warning-modal-text mt-4 mx-4">
        <p name="enable-copy">
          There {plural ? 'are' : 'is'} currently {voucherCount} voucher{plural ? 's' : ''} pending approval
          that use{plural ? '' : 's'} the current workflow. {plural ? 'These vouchers' : 'This voucher'} will be
          reset to the first step of the workflow, with no approvals.
        </p>
        <p>Are you sure you want to continue?</p>
      </div>
    </Modal>
  );
};

WarningModal.propTypes = {
  show: PropTypes.bool,
  voucherCount: PropTypes.number,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default WarningModal;
